import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=53f7d704&scoped=true&"
import script from "./ReportSection.vue?vue&type=script&lang=js&"
export * from "./ReportSection.vue?vue&type=script&lang=js&"
import style0 from "./ReportSection.vue?vue&type=style&index=0&id=53f7d704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7d704",
  null
  
)

export default component.exports